export const SEV_COLOR = {
  high: "#E24B4A", medium: "#eb7434", low: "#EF9F27",
  info: "#0d82b8", destination: "#7eadbb", shared: "#5b9bd5",
};

export const TYPE_COLOR = {
  rate: "#E24B4A", new_endpoint: "#D4537E", c2_beacon: "#7F77DD",
  frequency: "#EF9F27", hstrees: "#378ADD", cardinality: "#1D9E75",
  behavioral_change: "#D85A30", new_destination: "#BA7517", new_service: "#639922",
  rare_connection: "#9171d8", unusual_service: "#459095",
};

export const SEV_ORDER = { high: 0, medium: 1, low: 2, info: 3 };

export const QUICK_PORTS = [22, 3389, 21, 443, 80, 135, 139, 445, 8080];

// Spiegazioni mostrate nei tooltip dei tag di anomalia.
export const TYPE_DESCRIPTION = {
  rate: "Traffic volume (packets, bytes or connections over time) well above this host's usual level.",
  new_endpoint: "The host contacted an endpoint it has never talked to before.",
  c2_beacon: "Regular, periodic connections typical of command-and-control beaconing.",
  frequency: "A connection pattern is occurring much more (or less) often than its usual frequency.",
  hstrees: "Flagged by the Half-Space Trees model: the overall traffic profile looks unusual compared with normal behavior.",
  cardinality: "Unusual number of distinct peers, ports or services contacted.",
  behavioral_change: "Sustained shift away from the host's learned baseline behavior.",
  new_destination: "Traffic towards a destination not seen before in this host's history.",
  new_service: "Use of a service (port/protocol) the host has not used before.",
  rare_connection: "A connection that is rare compared with the usual communication graph.",
  unusual_service: "A service that is atypical for this host or destination.",
};

// Colore per uno score 0..1: da giallino (basso) a rosso intenso (alto).
export const scoreColor = (v) => {
  const t = Math.min(1, Math.max(0, v ?? 0));
  const from = [242, 194, 48];  // giallino
  const to   = [211, 47, 47];   // rosso intenso
  const rgb = from.map((c, i) => Math.round(c + (to[i] - c) * t));
  return `rgb(${rgb.join(",")})`;
};

// Filtri rapidi della lista Behaviors: si combinano in AND, applicati lato client.
const toMs = (v) => { const raw = v?.$date ?? v; return raw ? new Date(raw).getTime() : NaN; };
const peerCount = (a) =>
  a.graph?.total_peer_count ?? new Set((a.graph?.edges ?? []).map((e) => e.dst).filter(Boolean)).size;

export const QUICK_FILTERS = [
  { key: "open", label: "Open only", tip: "Only anomalies that are still open", test: (a) => a.status === "open" },
  { key: "active", label: "Active now", tip: "Seen in the last hour", test: (a) => Date.now() - toMs(a.last_seen) <= 60 * 60 * 1000 },
  { key: "high_score", label: "Score ≥ 0.8", tip: "Peak score of at least 0.8", test: (a) => (a.peak_score ?? 0) >= 0.8 },
  { key: "many_dst", label: "5+ destinations", tip: "Talks to at least 5 distinct destinations", test: (a) => peerCount(a) >= 5 },
];
